import { render, staticRenderFns } from "./Handle.vue?vue&type=template&id=69a9660f&scoped=true&"
import script from "./Handle.vue?vue&type=script&lang=ts&"
export * from "./Handle.vue?vue&type=script&lang=ts&"
import style0 from "./Handle.vue?vue&type=style&index=0&id=69a9660f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a9660f",
  null
  
)

export default component.exports